<script>
import Chart from 'chart.js'
import VueChartJs from 'vue-chartjs'
import zoom from 'chartjs-plugin-zoom'
import 'hammerjs'

export default {
  name: 'BubbleChart',
  extends: VueChartJs.Bubble,
  mixins: [VueChartJs.mixins.reactiveProp],
  data () {
    return {
      legendHtml: null
    }
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    genLegend: {
      type: Boolean,
      required: true
    },
    chartId: {
      type: String,
      default: '',
      required: false
    }
  },
  watch: {
    options: {
      handler (val) {
        if (this.genLegend && !this.legendHtml) {
          this.legendHtml = this.$data._chart.generateLegend()
        }
      },
      deep: true
    }
  },
  render: function (createElement) {
    return createElement(
      'div', {
        class: 'chart-wrapper',
        attrs: {
          id: this.chartId + '-wrapper'
        }
      },
      [createElement(
        'div', {
          style: this.styles,
          class: this.cssClasses
        },
        [createElement(
          'canvas', {
            attrs: {
              id: this.chartId,
              width: this.width,
              height: this.height
            },
            ref: 'canvas'
          }
        )
        ]
      ),
      createElement(
        'div', {
          attrs: {
            id: this.chartId + '-legend',
            class: 'chart-legend'
          },
          domProps: {
            innerHTML: this.legendHtml
          }
        }
      )]
    )
  },
  mounted () {
    this.addPlugin(zoom)
    Chart.defaults.global.events = ['click']
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BubbleChart.vue